export default __webpack_public_path__ + "static/media/add.47211ade.svg";